// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1949":"07f8d1cb","5553":"af872e18"}[chunkId] + ".chunk.css";
};